import { T, useGT } from 'gt-react';

// The tags a cell comment thread carries, shared by the thread itself and the
// review's comments panel entries.

/** A resolved thread's tag; its tooltip names who resolved it. */
export function ResolvedTag({
  resolvedByName,
}: {
  resolvedByName: string | null;
}) {
  const gt = useGT();
  return (
    <span
      className="shrink-0 rounded bg-emerald-100 px-1 text-[9px] font-semibold tracking-wide text-emerald-800 uppercase"
      title={
        resolvedByName
          ? gt('Resolved by {name}', {
              context: 'tooltip naming who resolved a cell comment thread',
              name: resolvedByName,
            })
          : undefined
      }
    >
      <T context="tag on a cell comment thread that has been resolved">
        Resolved
      </T>
    </span>
  );
}

/**
 * An orphaned thread's tag: its row has left the review, so the comments
 * panel doesn't jump to it.
 */
export function OrphanedTag() {
  const gt = useGT();
  return (
    <span
      className="shrink-0 rounded bg-stone-200 px-1 text-[9px] font-semibold tracking-wide text-stone-600 uppercase"
      title={gt(
        'The row this comment was left on is no longer in the review.',
        {
          context:
            'tooltip on a cell comment whose row was removed from the review',
        },
      )}
    >
      <T context="tag on a cell comment whose row was removed from the review">
        No longer in review
      </T>
    </span>
  );
}
